import z from "zod"

export const vehicleTypeFilterValues = [
	"CERTIFIED_USED_CAR",
	"CLASSIC",
	"COMMISSION_CAR",
	"COMPANY_CAR",
	"CUSTOMER_REPLACEMENT_CAR",
	"DEMO_CAR",
	"NEW_CAR",
	"USED_CAR",
] as const

export const vehicleTypeFilterSchema = z.enum(vehicleTypeFilterValues)

export type VehicleTypeFilter = z.infer<typeof vehicleTypeFilterSchema>
